import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { data } from './data'

import handshake from './handshake.png'
import leaf from './leaf.png'
import shield from './shield.png'

const StyledContents = styled.div`
  position: absolute;
  min-height: 80%;
  width: 100%;
  background-color: white;
  top: 20%;
  border-radius: 20px 20px 0 0;

  box-sizing: border-box;

  padding: 3em;
  padding-top: 120px;

  .tag-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    grid-gap: 10px;
    margin-bottom: 2em;
  }

  .tag {
    background-color: #EEEEEE;
    padding: 0.5em 1em;
    text-align: center;
    border-radius: 5px;
    width: auto;
    word-break: keep-all;

    font-size: 0.8em;
    font-weight: 600;

    box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.2);
  }

  h1 {
    font-size: 24px;
  }
`

const IconEllipse = styled.div`
  position: absolute;
  width: 150px;
  height: 180px;
  border-radius: 50%;
  left: 50%;
  top: 20%;
  transform: translate(-50%, -50%) rotate(45deg);

  background-color: #D2F825;

  box-shadow: 10px 10px 25px rgba(0, 0, 0, 0.1);
`

const StyledTitle = styled.div`
  position: absolute;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 20%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const DocumentStyle = styled.div`
font-size: 0.9em;
word-break: keep-all;
margin-bottom: 2em;

h1 {
  font-size: 1.2em;
}

ul {
  padding-left: 1.5em;
  line-height: 1.5em;
}
`
const ManifestoPage = () => {
  const [manifestoCategory, setManifestoCategory] = useState('친절한 성남')

  // url decode
  const decode = (str: string) => {
    return decodeURIComponent(str)
  }

  useEffect(() => {
    setManifestoCategory(decode(window.location.pathname.split('/')[2]))
  }, [])

  const datum = data.filter(datum => datum.category === manifestoCategory)[0]
  return (
    <>
    <StyledContents>
      <div className='tag-container'>
        {datum.tags.map(tag => (
          <div className='tag'>{tag}</div>
        ))}
      </div>
      {
        datum.manifestos.map(manifesto => (
          <DocumentStyle>
            <h1>{manifesto.title}</h1>
            <ul>
              {manifesto.contents.map(content => (
                <li>{content}</li>
              ))}
            </ul>
          </DocumentStyle>
        ))
      }
    </StyledContents>
    <IconEllipse>
    </IconEllipse>
    <StyledTitle>
        <img
        style = {{
          position: 'relative',
          width: '150%',
          transform: 'translate(0, -30%)',
        }}
        src={{
          '친절한 성남': handshake,
          '여유로운 성남': leaf,
          '안전한 성남': shield,
        }[datum.category]}
        alt={datum.category}
        />
    </StyledTitle>
    <h2
      style={{
        fontSize: '1.2em',
        position: 'absolute',
        top: '22%',
        left: '49%',
        textAlign: 'center',
        transform: 'translate(-50%, -50%)',
      }}
    >
      {datum.category}
    </h2>
    </>
  )
}

export default ManifestoPage